import Head from 'next/head';
import React, { useEffect } from 'react';
import LazyLoad, { lazyload, forceCheck } from 'react-lazyload';
import st from './index.module.css';
import Engagement from '../../components/Engagement';
import Matrix from '../quote/video-production/Matrix';
import Multiservice from '../../components/custom-landings/Multiservice';
import PagesToLife from '../../components/custom-landings/PagesToLife';
import ExamplesSLider from '../../components/custom-landings/ExamplesSlider';
import Faq from '../../components/Faq';
import AdditionalPPCSlider from '../../components/sliders/AdditionalPPCSLider';
import SchedulaACall from '../../components/Base/SchedulaACall';
lazyload({
  width: '100%',
});
const PaidAdvertiseingServices = props => {
  const textLength = 40;
  useEffect(() => {
    forceCheck();
  }, []);
  const generateAnimation = () => {
    setInterval(function () {
      document.querySelectorAll('.num_count').forEach(function (element, index) {
        if (element.innerText.length < textLength) {
          element.innerText = element.innerText + Math.round(Math.random());
        } else {
          element.innerText = Math.round(Math.random()) + element.innerText.substring(0, element.innerHTML.length - 1);
        }
      });
    }, 395);
  };
  // generateAnimation()
  return (
    <>
      <Head>
        <title>Custom Landing Pages That Generate Leads</title>
        <link rel="alternate" hrefLang="en" href="https://weprodigi.com/landing-pages-that-generate-leads" />
        <meta
          name="description"
          content="We help businesses increase their revenue through Paid Advertising Services on Google, Youtube, Facebook, Instagram, Bing, Yahoo and etc."
        />
        <meta property="og:url" content="https://weprodigi.com/landing-pages-that-generate-leads" />
        <meta property="og:type" content="article" />
        <meta property="og:title" content="Custom Landing Pages That Generate Leads" />
        <meta
          property="og:description"
          content="We help businesses increase their revenue through Paid Advertising Services on Google, Youtube, Facebook, Instagram, Bing, Yahoo and etc."
        />
        <meta property="og:image" content="https://weprodigi.com/images/landing-pages-that-generate-leads/og.png" />
      </Head>
      <div className="intro relative w-full h-800 md:h-600   bg-gray-light bg-grid MontserratArm">
        <div className="relative  h-800 md:h-600 md:flex md:items-center py-12p">
          <div className="container">
            <div className="relative z-10 flex flex-col flex-wrap justify-center items-start h-3/6 md:pb-90 md:mb-120 lg:mb-0 lg:pb-90">
              <p className="text-black md:text-black uppercase md:capitalize font-black md:font-bold text-30 md:text-60 leading-38 md:leading-73">
                Custom Landing Pages <br /> That Generate Leads
              </p>
              <button
                className={'hidden md:flex items-center cursor-pointer  py-8 bg-green-badge hover:bg-green-hover text-white px-20 rounded-5 mt-24'}
                onClick={() => {
                  document.documentElement.style.overflow = 'hidden';
                }}
              >
                Tell More, Get More
                <img
                  src="https://admin.weprodigi.com//uploads/files/shares/ppc/header-button.svg"
                  className={'ml-15'}
                  width={23}
                  alt="header-button"
                />
              </button>
            </div>
          </div>
          <div className="absolute w-full h-full top-auto left-0 bottom-0">
            <div className="ruller absolute left-0 bottom-0 z-10" />
            <div className="ruller ruller2 hidden md:block absolute left-auto top-0" />
            <div className="overlay absolute w-full md:w-1/3 h-480 md:h-full top-auto bottom-0 left-auto right-0 bg-purple">
              <div className="personage-container">
                <div className="personage relative md:absolute w-100p  left-0 md:-left-200 md:w-4/5 lg:w-full h-auto bottom-0 md:right-0  ">
                  <div className={st['device-part']}>
                    <div className={st.desktop}>
                      <img src="https://weprodigi.com/uploads/images/custom-landings/desktop_Icon.png" width={25} alt="desktop_Icon" />
                      <span>desktop device</span>
                    </div>
                    <div className={st.mobile}>
                      <span>Mobile Device</span>
                      <img src="https://weprodigi.com/uploads/images/custom-landings/mobile_Icon.png" width={15} alt="mobile_Icon" />
                    </div>
                    <div className={st.tablet}>
                      <img
                        className={'mr-10'}
                        src="https://weprodigi.com/uploads/images/custom-landings/tablet_Icon.png"
                        width={20}
                        alt="tablet_Icon"
                      />
                      <span>tablet Device</span>
                    </div>
                  </div>
                  <img
                    width="565"
                    className="mx-auto relative"
                    src="https://weprodigi.com/uploads/images/custom-landings/header_girl.png"
                    alt={'personage'}
                  />
                  {/*<div className={"absolute w-100 h-30 bg-green left-55p top-60 overflow-hidden text-white text-11 leading-none " + st['dual-animation']}>*/}
                  {/*    <div className={st.num + " num_count"}>01010000011100100110111101100100011010010110011101101001001000000100001001100101011100110111010000100000010001000110100101100111011010010111010001100001011011000010000001000011011011110110110101110000011000010110111001111001</div>*/}
                  {/*    <div className={st.num + " num_count"}>01010000011100100110111101100100011010010110011101101001001000000100001001100101011100110111010000100000010001000110100101100111011010010111010001100001011011000010000001000011011011110110110101110000011000010110111001111001</div>*/}
                  {/*    <div className={st.num + " num_count"}>01010000011100100110111101100100011010010110011101101001001000000100001001100101011100110111010000100000010001000110100101100111011010010111010001100001011011000010000001000011011011110110110101110000011000010110111001111001</div>*/}
                  {/*    <div className={st.num + " num_count"}>01010000011100100110111101100100011010010110011101101001001000000100001001100101011100110111010000100000010001000110100101100111011010010111010001100001011011000010000001000011011011110110110101110000011000010110111001111001</div>*/}
                  {/*    <div className={st.devider + " " + st.d00}></div>*/}
                  {/*    <div className={st.devider + " " + st.d01}></div>*/}
                  {/*    <div className={st.devider + " " + st.d02}></div>*/}
                  {/*    <div className={st.devider + " " + st.d03}></div>*/}
                  {/*    <div className={st.devider + " " + st.d04}></div>*/}
                  {/*</div>*/}
                  <div className={st.choker}>
                    <Matrix w={200} fontSize={10} background="#8DC63F" id="canvas1" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <LazyLoad height={200} once>
        <div className="engagement relative py-23 md:bg-white">
          <div className="container">
            <Engagement title="Video">
              Welcome to WeProdigi, where custom landing pages are our specialty. We understand the importance of a well-designed and optimized
              landing page for any business looking to make a strong online presence and drive results. As the first point of contact between a
              potential customer and your brand, a landing page can either make or break your conversion goals. That's why we are dedicated to
              creating landing pages that not only look great but are also optimized for maximum conversion. We take the time to understand your
              business goals and create a landing page that aligns with your marketing strategy and clearly conveys your value proposition. Our team
              of experienced designers, marketers and developers will work with you every step of the way to ensure your landing page drives leads,
              sales, and achieves your desired outcomes. At WeProdigi, we're passionate about helping businesses succeed online, and we're ready to do
              the same for you.
            </Engagement>
          </div>
        </div>
      </LazyLoad>
      <LazyLoad height={200} once>
        <div className="relative py-23">
          <Multiservice
            id="explainer-video"
            title={
              <span className="leading-none">
                Landing page <br /> design
              </span>
            }
            titleNode="LANDING PAGE DESIGN"
            about="Custom-designed landing pages are crucial for the success of online marketing efforts in various industries. From e-commerce to B2B, healthcare to technology, a well-designed landing page can increase conversions, drive sales, communicate value propositions, build trust, and stand out from the competition. We use the latest and most advanced tools, such as Adobe XD, Figma, and Sketch, to create custom landing page designs. Our professional team leverages these tools to create visually appealing, responsive landing pages that deliver results, with competitive advantages like a conversion-focused approach, expertise in digital user behavior, and unlimited revisions. Our services are 100% custom and oriented towards the specifications of each client's brand, ensuring that the final product is unique and tailored to their needs.At WeProdigi, we understand the importance of having a custom-designed landing page for businesses in all industries. With our years of experience, advanced tools, and expertise, we are confident that we can deliver custom landing page designs that drive results for our clients. Take the next step to improve your online marketing efforts today by contacting us to learn more about our landing page design services!"
            order={{
              columns: 2,
              content: [
                'Research and analysis',
                'Wireframing',
                'Visual Design',
                'Lead Generation Forms',
                'Testing and Optimizations',
                'Mobile-Friendly Design',
                'Final Delivery',
              ],
            }}
            preview={{
              type: 'video',
              url: '/videos/Explainervideo.mp4',
              poster: '/images/posters/video-production/explainer.jpg',
              aspect: {
                type: 'ratio',
                num: '16-9',
              },
            }}
            price={{
              usd: '$1200',
              eur: '€1000',
              gbp: '£1000',
              aud: 'A$1600',
              sgd: 'S$1600',
              cad: 'C$1600',
              rub: '90000 ₽',
              nzd: 'NZ$ 1700',
            }}
            includeText={'Order Includes'}
            price_title="Price"
            actionButton={true}
            actionButtonText="More Videos"
            actionButtonLink="https://www.youtube.com/playlist?list=PLHJMKI8WX4RYaTdB13PaRsm_MsgnLZmuG"
            icon="icon-video icon-video-1"
            quote={{
              text: 'Order Now',
            }}
            country={props.country}
            currency={props.currency}
          />
          <Multiservice
            id="explainer-video"
            title={
              <span className="leading-none">
                Landing page <br /> Creation
              </span>
            }
            titleNode="LANDING PAGE Creation"
            about="WeProdigi creates effective landing pages that convert visitors into customers. Our services cater to industries such as e-commerce, healthcare, real estate, education, technology and etc. We use the latest tools and technologies, including Adobe Creative Suite, Sketch, Figma, HTML5, CSS3, JavaScript, and WordPress, to ensure top-notch landing pages. Our landing page creation services offer several competitive advantages, including a customized design that reflects your brand, user-friendly experience, mobile responsiveness, and fast loading speed. Our goal is to provide you with a landing page that not only looks great but also functions optimally, helping you achieve your goals and reach your target audience. Whether you're looking to generate leads, build brand awareness, or drive sales, we have the skills and expertise to help you succeed. Ready to enhance your online presence? Contact us today to start your custom landing page project! Our team will help you turn visitors into customers and reach your goals online."
            order={{
              columns: 2,
              content: [
                'Research and analysis',
                'Wireframing',
                'Visual Design',
                'Lead Generation Forms',
                'Content Creation',
                'Web Development',
                'Testing and Optimizations',
                'Final Delivery',
              ],
            }}
            preview={{
              type: 'video',
              url: '/videos/Explainervideo.mp4',
              poster: '/images/posters/video-production/explainer.jpg',
              aspect: {
                type: 'ratio',
                num: '16-9',
              },
            }}
            price={{
              usd: '$1200',
              eur: '€1000',
              gbp: '£1000',
              aud: 'A$1600',
              sgd: 'S$1600',
              cad: 'C$1600',
              rub: '90000 ₽',
              nzd: 'NZ$ 1700',
            }}
            includeText={'Order Includes'}
            price_title="Price"
            actionButton={true}
            actionButtonText="More Videos"
            actionButtonLink="https://www.youtube.com/playlist?list=PLHJMKI8WX4RYaTdB13PaRsm_MsgnLZmuG"
            icon="icon-video icon-video-1"
            quote={{
              text: 'Order Now',
            }}
            country={props.country}
            currency={props.currency}
          />
          <Multiservice
            id="explainer-video"
            title={
              <span className="leading-none">
                Landing Page Creation <br /> and Conversion Optimization
              </span>
            }
            titleNode="Landing Page Creation and Conversion Optimization"
            about="We are dedicated to creating top-performing landing pages for businesses of all industries. With our focus on design, web development, and conversion optimization, you can trust us to deliver results that drive conversions and maximize your return on investment. Whether you're in travel, healthcare, finance, or any other industry, our team of experts has the knowledge and experience to help you achieve your goals. By leveraging the latest tools and software in the market, we can create a custom landing page that is tailored to your specific needs and target audience. Take the travel industry, for example. With the right landing page, a travel company can boost bookings and drive revenue by showcasing their destinations, packages, and special deals in a visually appealing and user-friendly manner. By incorporating conversion optimization strategies, such as clear calls-to-action and persuasive copy, we can help increase the likelihood of visitors taking the desired action. Contact us today to learn more about our custom landing page creation and conversion optimization services. Our team of experts is standing by to help you achieve your goals and maximize your return on investment. Let's get started on creating a landing page that drives conversions and elevates your business to new heights."
            order={{
              columns: 2,
              content: [
                'Custom landing page design and development',
                'Conversion rate optimization',
                'User experience analysis',
                'Call-to-action optimization',
                'Persuasive copywriting',
                'Data analysis and tracking',
                'Ongoing optimization and maintenance',
              ],
            }}
            preview={{
              type: 'video',
              url: '/videos/Explainervideo.mp4',
              poster: '/images/posters/video-production/explainer.jpg',
              aspect: {
                type: 'ratio',
                num: '16-9',
              },
            }}
            price={{
              usd: '$1200',
              eur: '€1000',
              gbp: '£1000',
              aud: 'A$1600',
              sgd: 'S$1600',
              cad: 'C$1600',
              rub: '90000 ₽',
              nzd: 'NZ$ 1700',
            }}
            includeText={'Order Includes'}
            price_title="Price"
            actionButton={true}
            actionButtonText="More Videos"
            actionButtonLink="https://www.youtube.com/playlist?list=PLHJMKI8WX4RYaTdB13PaRsm_MsgnLZmuG"
            icon="icon-video icon-video-1"
            quote={{
              text: 'Order Now',
            }}
            country={props.country}
            currency={props.currency}
          />
          <Multiservice
            id="explainer-video"
            title={
              <span className="leading-none">
                Landing Page Creation, <br /> CR optimization and PPC Services
              </span>
            }
            titleNode="Landing Page Creation, CR optimization and PPC Services"
            about="We provide a one-stop solution for all your landing pages, conversion rate optimization, and pay-per-click advertising needs. Our focus is to help businesses of all industries increase their conversion rates and maximize their return on investment. No matter what industry you're in, we can help you achieve your goals. From technology and education to retail and food and beverage, our team of experts has the knowledge and experience to deliver results that drive conversions and grow your business. We use the latest tools and software to design and develop landing pages that are tailored to your specific needs and target audience. Our team of experts uses the latest tools and software for custom landing page development, including Adobe Creative Suite, Sketch, Figma, and HTML/CSS/JavaScript. We also use A/B testing and heatmap tools to continually optimize and improve the performance of your landing pages. In addition to landing page creation and conversion rate optimization, we also offer pay-per-click (PPC) services to help you reach your target audience through highly targeted and cost-effective advertising. As an official Google Ad partner agency, we have the expertise and experience to help you achieve your goals and grow your business through PPC advertising. Don't miss out on the opportunity to increase your conversion rates and grow your business. Contact us today to learn how we can help you achieve your goals."
            order={{
              columns: 2,
              content: [
                'Custom landing page design and development',
                'Conversion rate optimization',
                'User experience analysis',
                'A/B testing',
                'Call-to-action optimization',
                'Persuasive copywriting',
                'Pay-per-click Advertising',
                'Data analysis and tracking',
                'Ongoing optimization and maintenance',
              ],
            }}
            preview={{
              type: 'video',
              url: '/videos/Explainervideo.mp4',
              poster: '/images/posters/video-production/explainer.jpg',
              aspect: {
                type: 'ratio',
                num: '16-9',
              },
            }}
            price={{
              usd: '$1200',
              eur: '€1000',
              gbp: '£1000',
              aud: 'A$1600',
              sgd: 'S$1600',
              cad: 'C$1600',
              rub: '90000 ₽',
              nzd: 'NZ$ 1700',
            }}
            includeText={'Order Includes'}
            price_title="Price"
            actionButton={true}
            actionButtonText="More Videos"
            actionButtonLink="https://www.youtube.com/playlist?list=PLHJMKI8WX4RYaTdB13PaRsm_MsgnLZmuG"
            icon="icon-video icon-video-1"
            quote={{
              text: 'Order Now',
            }}
            country={props.country}
            currency={props.currency}
          />
        </div>
      </LazyLoad>
      <LazyLoad height={200} once>
        <div className="relative py-23 bg-gray-light">
          <div className="container">
            <h1 className={'text-purple text-24 md:text-36 font-black leading-44 uppercase mb-20'}>
              Bring Your Landing Pages to Life:
              <br /> Say Hello to High Conversions
            </h1>
            <Engagement title="Video">
              Welcome to a new era of landing pages that drive conversions and grow your business. Say goodbye to boring and lackluster landing pages
              that fail to engage your target audience. With our expert team and cutting-edge tools, we'll help bring your landing pages to life and
              turn them into powerful conversion generators. Say hello to higher conversions and increased ROI as we help you make the most of your
              online presence. Get ready to take your landing pages to the next level.
            </Engagement>
            <PagesToLife />
          </div>
        </div>
      </LazyLoad>
      <LazyLoad height={200} once>
        <div className="relative py-23 bg-white">
          <div className="container">
            <h1 className={'text-purple text-24 md:text-36 leading-44 font-black uppercase'}>landing pages gallery</h1>
            <ExamplesSLider currency={props.currency} />
          </div>
        </div>
      </LazyLoad>
      <LazyLoad height={300} once>
        <div className={`bg-gray-light`}>
          <div className={`image-left-block py-30 container`}>
            <h1 className={'text-purple text-24 md:text-36 leading-28 md:leading-44 font-black uppercase'}>
              Why should you include Paid Ads services <br />
              in your marketing plan?
            </h1>
            <div className="flex   flex-wrap-reverse">
              <div className="w-full md:w-50p mt-30 relative">
                <div className={st['left-part']}>
                  <Matrix fontSize={18} background="#F4E5F8" id="canvas2"></Matrix>
                </div>
                <img
                  src="https://weprodigi.com/uploads/images/custom-landings/funnel.png"
                  width={589}
                  height={600}
                  alt="search"
                  className={'relative'}
                />
              </div>
              <div className="w-full md:w-50p mt-10 md:mt-15 pl-0 md:pl-30">
                <div className="w-full mt-10 pl-0 md:pl-15">
                  <h2 className="text-purple font-bolder text-16 ">Tailored design</h2>
                  <p className="text-16 text-black">
                    With our custom-designed landing pages, you can be sure that your brand, audience, and goals are taken into consideration to
                    increase the likelihood that visitors will engage with your page and take action.
                  </p>
                </div>
                <div className="w-full mt-10 pl-0 md:pl-15">
                  <h2 className="text-purple font-bolder text-16 ">Clear messaging</h2>
                  <p className="text-16 text-black">
                    Our services deliver clear messaging that resonates with your target audience. Our team of experts create a custom design and
                    effective copy to reduce confusion and increase conversions. We take the time to understand your specific needs and design a
                    landing page that meets them, whether you're looking to generate leads or promote a new product or service.
                  </p>
                </div>
                <div className="w-full mt-10 pl-0 md:pl-15">
                  <h2 className="text-purple font-bolder text-16 ">Optimization for conversions</h2>
                  <p className="text-16 text-black">
                    We use industry best practices to optimize your landing page for conversions, incorporating clear and prominent calls to action,
                    persuasive copy, and visually appealing design. Our approach is designed to encourage visitors to take the desired action and
                    increase the probability of conversion.
                  </p>
                </div>
                <div className="w-full mt-10 pl-0 md:pl-15">
                  <h2 className="text-purple font-bolder text-16 ">Analytics tracking</h2>
                  <p className="text-16 text-black">
                    Our analytics tracking helps you measure the success of your landing page and make data-driven improvements, tracking important
                    metrics such as click-through rates, bounce rates, and conversion rates.
                  </p>
                </div>
                <div className="w-full mt-10 pl-0 md:pl-15">
                  <h2 className="text-purple font-bolder text-16 ">Time-saving approach</h2>
                  <p className="text-16 text-black">
                    Outsourcing your landing page creation to WeProdigi can save you time, allowing you to focus on other areas of your business. We
                    can help increase your productivity and overall efficiency, delivering results that you can rely on.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </LazyLoad>
      <LazyLoad>
        <div className={`bg-white z-12222`}>
          <div className={`image-left-block py-30 container`}>
            <h1 className={'text-purple text-24 font-black uppercase'}>Future-Ready Web Development Expertise from Our Team</h1>
            <div className="flex flex-wrap">
              <div className="w-full md:w-50p mt-30 ">
                At WeProdigi, we are proud to have a team of expert web developers who possess a wide range of skills and expertise to make your
                website future-ready. Our in-house team of expert web developers is equipped with the latest tools and technologies to provide
                customized solutions that cater to your specific needs. Our team has a proven track record of delivering outstanding web development
                projects for clients across various industries. From simple landing pages to complex e-commerce platforms, our team can handle it all.
                We believe in a collaborative approach that puts our clients' needs first, ensuring that we deliver solutions that exceed
                expectations. Our expertise includes a deep understanding of various programming languages, including HTML, CSS, JavaScript, and PHP,
                to name a few. We also have extensive experience working with content management systems (CMS) like WordPress, Shopify, and Magento.
                This expertise allows us to provide customized solutions that cater to your specific needs. In addition to our technical expertise, we
                also place a strong emphasis on providing excellent customer service. We understand that every client has unique requirements, and we
                work closely with them to ensure that their vision is realized. Our team is always available to answer questions, provide support, and
                make any necessary changes to ensure that you are completely satisfied with the final product.
              </div>
              <div className="w-full md:w-50p mt-30 pl-0 md:pl-30">
                <picture>
                  <source media="(min-width:768px)" srcSet="/images/team/PM-group_images.png" type="image/png" />
                  <source media="(max-width:768px)" srcSet="/images/team/PM-group_images.png" type="image/png" />
                  <img src="" width={539} height={303} alt="" />
                </picture>
              </div>
            </div>
          </div>
        </div>
      </LazyLoad>
      <LazyLoad height={200} once>
        <div className="bg-gray-white">
          <div className="container py-23">
            <p className="uppercase text-30 md:text-36 mb-23 font-black text-purple leading-none">FAQ</p>
            <div className="grid md:grid-cols-2 md:gap-30">
              <Faq
                content={[
                  {
                    title: 'How long does the video production process take?',
                    answer:
                      'On average, our usual production cycle requires from three to five weeks. But if you have a set deadline, we always try to offer custom solutions without any extra fees.',
                  },
                  {
                    title: 'How much involvement will I have?',
                    answer:
                      'It is totally up to you. We have created a production process where everything is created to save your time. At the same time, you can be integrated in every process of our production and hold discussions and brainstorming with us.',
                  },
                  {
                    title: 'What if I want to use my own script in the video?',
                    answer:
                      "There is no problem. We'll give it a look and provide feedback on its viability for the objectives you want to accomplish and help to improve it, if there is a need, free of charge.",
                  },
                  {
                    title: 'What if I have a difficult technology to explain on the video ?',
                    answer:
                      'From Engineering to healthcare, our scriptwriters are skilled in any field and are ready to apply their knowledge in a new field and in a new direction in order to get the desired result. Before working on the script and the original video, our specialists get acquainted with the details of the field and the project during the research and discovery stages. In addition, you have the option to change the script until we get the result you want free of any charges.',
                  },
                  {
                    title: 'In which channels can I use my video?',
                    answer:
                      'You can use the video in any channel. In addition, we may provide free consultation about-us-new this topic. We can adapt it to different sizes and requirements.',
                  },
                ]}
              />
              <Faq
                content={[
                  {
                    title: 'I want to stop the project, what will happen?',
                    answer:
                      'We have created a model of cooperation where no one will be affected. The project is divided into milestones and you pay only for the work that is finished and approved. For example, if you have approved the script, storyboard, voiceover, design but you have to stop the project, you only need to pay for those services, as well as we provide the source materials so you can use them at any time.',
                  },
                  {
                    title: 'How do you manage projects?',
                    answer:
                      'At the beginning of each video, we create an action plan which will outline all the stages of the production processes, the timelines, and the deadlines as well. You will have the advantage to follow up with the project’s stages in real-time. This helps to ensure that there is 100% transparency at all times.',
                  },
                  {
                    title: 'What if I want multiple videos?',
                    answer:
                      'In the case of multiple videos, we provide an exclusive rate and other benefits to our clients to make the project mutually beneficial. The videos can be created either simultaneously or gradually. Moreover, we provide a free demo version which will reassure you made the right decision by choosing us.',
                  },
                  {
                    title: 'What about payment?',
                    answer:
                      "We believe that the client should pay for the finished work, rather than with a deposit. That’s why we choose a milestone payment option, as we believe that it's a more trustworthy approach in our work. You can have all the needed information about-us-new our payment terms here.",
                  },
                  {
                    title: 'What if I want to create a video in other languages?',
                    answer:
                      'We have script writers who are native in German, French, Spanish, and Russian. In case you want your script to be in another language, we work with native translators to create videos in any preferred langauges.',
                  },
                ]}
              />
            </div>
          </div>
        </div>
      </LazyLoad>
      <LazyLoad height={300} once>
        <div className={`bg-white`}>
          <div className=" container py-23">
            <p className="text-purple text-30 md:text-36 uppercase font-black mb-23 leading-none">additional MARKETING services</p>
            <AdditionalPPCSlider />
          </div>
        </div>
      </LazyLoad>
      <SchedulaACall
        country={props.country}
        width={props.width}
        url="https://calendar.app.google/uJZkJfztLwHZcfkC7"
      />
    </>
  );
};

export default PaidAdvertiseingServices;
